import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import { getDownloadAllUserAcc, getDownloadUserAcc, getRoles } from "./utils";

//Create the Context
const DownloadUsersContext = createContext();

//Create a Provider component

export const DownloadUserProvider = ({ children }) => {
  const [downloadAllUserAcc, setDownloadAllUserAcc] = useState(null);
  const [downloadUserAcc, setDownloadUserAcc] = useState(null);
  const [selectedDownloadUserAcc, setSelectedDownloadUserAcc] = useState(null);
  const [reload, setReload] = useState(true);
  const [roles, setRoles] = useState(null);
  const [selectedRoleBtn, setSelectedRoleBtn] = useState(false);
  const [authenticationChecked, setAuthenticationChecked] = useState("Success");

  const loadDownloadAllUserAcc = useCallback(() => {
    getDownloadAllUserAcc(setDownloadAllUserAcc, setAuthenticationChecked);
  });
  useEffect(() => {
    loadDownloadAllUserAcc();
    setReload(false);
  }, [reload]);

  useEffect(() => {
    if (
      selectedDownloadUserAcc != null &&
      selectedDownloadUserAcc.id !== null
    ) {
      getDownloadUserAcc(selectedDownloadUserAcc.id, setDownloadUserAcc);
      getRoles(selectedDownloadUserAcc.id, setRoles);
    }
  }, [selectedDownloadUserAcc]);

  return (
    <DownloadUsersContext.Provider
      value={{
        downloadAllUserAcc,
        downloadUserAcc,
        selectedDownloadUserAcc,
        setDownloadAllUserAcc,
        setDownloadUserAcc,
        setSelectedDownloadUserAcc,
        setReload,
        roles,
        setRoles,
        selectedRoleBtn,
        setSelectedRoleBtn,
        authenticationChecked,
        setAuthenticationChecked,
      }}
    >
      {children}
    </DownloadUsersContext.Provider>
  );
};

// Custom hook to use the DownloadUsersContext
export const useDownloadUsers = () => {
  const context = useContext(DownloadUsersContext);
  if (!context) {
    throw new Error(
      "useDownloadUsers must be used within an DownloadUserProvider",
    );
  }
  return context;
};
